import { render, staticRenderFns } from "./Planmanagement.vue?vue&type=template&id=870f5ffa&"
import script from "./Planmanagement.vue?vue&type=script&lang=js&"
export * from "./Planmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports